/** Pull a user-facing login failure message from API / axios errors. */
export function extractLoginApiErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const data = (error as { response?: { data?: { message?: string } } }).response?.data;
    const api_message = data?.message;
    if (typeof api_message === 'string' && api_message.trim()) {
      return api_message.trim();
    }
  }
  if (error instanceof Error) {
    const message = error.message.trim();
    if (message && message !== 'Network Error') {
      return message;
    }
  }
  return fallback;
}
